import { BreadCrumb } from "./BreadCrumb";

export function LoadingVideos(props: { breadcrumb: string[] }) {
	return (
		<div className="md:mt-16 px-4 text-white">
			<BreadCrumb steps={[...props.breadcrumb, "Carregando..."]} />
		</div>
	);
}
